export default __webpack_public_path__ + "static/media/GU.a55e2ec9.svg";